import React, { useEffect, useRef, useState } from "react";
import accbgimg from "../Images/accbgimg.png";
import accpngprofpic from "../Images/accpngprofpic.png";
import namesidestar from "../Images/namesidestar.png";
import checkIcon from "../Images/CheckIconG.png";
import editicon from "../Images/editicon.png";
import passwordupdategif from "../Images/passwordupdategif.gif";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../features/user/userSlice";
import Navbar from "../features/navbar/Navbar";
import Footer from "./Footer";
import {
  checkAadhaarAsync,
  clearAadhaarDetails,
  fetchAadhaarDetailsAsync,
  resetAadhaarOTPVerified,
  selectAadhaarDetails,
  selectIsOTPVerified,
  selectOTP,
  setOTPVerified,
} from "../features/property/AadhaarDetailsSlice";
import { toast } from "react-toastify";
import {
  checkUserMobileAsync,
  createUserAsync,
  fetchDistrictDataAsync,
  fetchStateDataAsync,
  selectDistrictOptions,
  selectStateOptions,
  setOTP,
} from "../features/auth/authSlice";
import {
  fetchGender,
  fetchIDTypeData,
  fetchRelationData,
} from "../features/PartyDetail/PartyDetailSlice";
import { useForm } from "react-hook-form";
import {
  clearOTPs,
  fetchOTPs,
} from "../features/modal/modalSlices/MobileEmailModalSlice";
import { BsFillKeyFill } from "react-icons/bs";
import axios from "axios";
import API_BASE_URL from "../features/BaseURL/baseURL";

const OTPInput = ({ length = 4, onOtpChange, onResendOTP }) => {
  const inputs = useRef([]);
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);
  const [timer, setTimer] = useState(30);
  const [otpResent, setOtpResent] = useState(false);
  let newOtp;

  useEffect(() => {
    let interval;
    if (otpResent) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setOtpResent(false);
            return 30;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpResent]);

  const handleChange = (index, e) => {
    const digit = e.target.value.slice(-1);
    if (/^\d$/.test(digit) || digit === "") {
      newOtp = [...otp];
      newOtp[index] = digit;
      setOtp(newOtp);
      onOtpChange(newOtp.join(""));

      // Auto-focus to next field if not the last one
      if (digit && index < length - 1) {
        inputs.current[index + 1]?.focus();
      }
    }

    // Check if all fields are filled
    setAllFieldsFilled(newOtp.every((val) => val !== ""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };

  const handleResendOTP = () => {
    setOtp(new Array(length).fill(""));
    setOtpResent(true);
    onResendOTP();
  };

  return (
    <div className="container flex items-center space-x-2">
      <div className="flex mb-3">
        {[...Array(length)].map((_, index) => (
          <div key={index} className="mx-1">
            <input
              type="text"
              maxLength={1}
              className="form-control text-center border border-gray-300 rounded w-10 h-10"
              ref={(el) => (inputs.current[index] = el)}
              value={otp[index]}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const VerificationSection = ({
  label,
  id,
  field,
  register,
  getValues,
  setValue,
  watch,
  validation,
  fetchOtpAction,
  disabled = false,
  hideButton = false,
}) => {
  const dispatch = useDispatch();
  const [showOTP, setShowOTP] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [verified, setVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const user = useSelector(selectUser);
  const inputValue = watch(id);

  useEffect(() => {
    let interval;
    if (otpSent) {
      setCanResend(false);
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setCanResend(true);
            return 30;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpSent]);

  // Function to send OTP
  const handleSendOTP = async () => {
    const value = getValues(id); // ✅ Get the value for the current field

    // ✅ Send only the selected field when verifying individually
    let payload = {};
    if (field === "mobile" && value) payload.mobile = value;
    if (field === "email" && value) payload.email = value;
    if (field === "whatsapp" && value) {
      payload.whatsappNo = value;
      payload.firstName = user?.firstName; // ✅ Required for WhatsApp OTP
    }

    if (Object.keys(payload).length === 0) {
      console.warn("No valid field found to send OTP.");
      return;
    }

    const res = dispatch(fetchOTPs(payload));

    res.then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        setShowOTP(true);
        setOtpSent(true);

        // ✅ Update OTP state only for the verified field
        if (field === "mobile") setGeneratedOtp(result.payload?.mobileOtp);
        if (field === "email") setGeneratedOtp(result.payload?.emailOtp);
        if (field === "whatsapp") setGeneratedOtp(result.payload?.whatsappOtp);

        console.log(`OTP Sent for ${field}:`, result.payload);
      } else {
        console.error("OTP fetch failed:", result.payload);
      }
    });
  };

  // Function to verify entered OTP
  const handleVerify = () => {
    if (otp === generatedOtp) {
      setVerified(true);
      dispatch(clearOTPs());
      setOtpSent(false);
    } else {
      toast.error("Incorrect OTP. Please try again.");
    }
  };

  return (
    <div>
      {/* Input and Verify Button */}
      <div className="relative flex items-center">
        <label
          htmlFor={id}
          className={`absolute left-2 -top-3 bg-white px-1 text-gray-600 text-xs peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm transition-all duration-200 ${
            disabled ? "text-gray-400" : "text-gray-600"
          }`}
        >
          {label}
        </label>
        <input
          {...register(id, validation)} // ✅ Ensure register is applied correctly
          value={inputValue} // ✅ Track input changes
          disabled={disabled}
          onChange={(e) => setValue(id, e.target.value)} // ✅ Update form state
          className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
        />
        {!hideButton && (
          <button
            className={`ml-2 text-white text-xs px-3 py-1 rounded 
            ${
              verified
                ? "bg-green-600"
                : otpSent
                ? "bg-orange-500"
                : "bg-blue-500"
            }
          `}
            onClick={verified ? null : handleSendOTP}
            disabled={verified}
          >
            {verified ? "Verified" : otpSent ? "Resend" : "Change"}
          </button>
        )}
      </div>

      {/* Show Timer Below Resend Button */}
      {otpSent && !verified && (
        <div className="mt-2 text-center">
          <p className="text-gray-600 text-sm">
            {canResend
              ? ""
              : `Resend OTP in 00:${timer < 10 ? `0${timer}` : timer}`}
          </p>
        </div>
      )}

      {/* OTP Input Section */}
      {showOTP && !verified && (
        <div className="flex flex-col items-center justify-between mt-3">
          <OTPInput
            length={4}
            onOtpChange={setOtp}
            onResendOTP={handleSendOTP}
          />
          <button
            className="mt-2 bg-blue-500 text-white text-xs px-3 py-1 rounded"
            onClick={handleVerify}
            disabled={verified}
          >
            Verify
          </button>
        </div>
      )}
    </div>
  );
};

const Profile = () => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm();
  const stateOptions = useSelector(selectStateOptions);
  const { idTypeData } = useSelector((state) => state.PartyDetail);
  const { relationData, genderData } = useSelector(
    (state) => state.PartyDetail
  );
  const districtOptions = useSelector(selectDistrictOptions);
  const isOTPVerified = useSelector(selectIsOTPVerified);
  const aadhaarDetails = useSelector(selectAadhaarDetails);
  const user = useSelector(selectUser);
  console.log(user);
  const mobotp = useSelector((state) => state.auth.otp);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showEmailOTP, setShowEmailOTP] = useState(false);
  const [showWhatsAppOTP, setShowWhatsAppOTP] = useState(false);
  const [emailOtp, setEmailOtp] = useState(["", "", "", ""]);
  const [whatsAppOtp, setWhatsAppOtp] = useState(["", "", "", ""]);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [showPasswordUpdateSuccessForm, setShowPasswordUpdateSuccessForm] =
    useState(false);
  const [otpPassword, setOtpPassword] = useState(["", "", "", ""]);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showEkycForm, setShowEkycForm] = useState(false);
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [timeLeft, setTimeLeft] = useState(54);
  const [isChecked, setIsChecked] = useState(false);
  const [canResend, setCanResend] = useState(false);
  // const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const selectedState = watch("state");
  const [state, setState] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");
  const ekyc = String(user?.aadhaar_ekyc || "");
  console.log(ekyc);
  const storedOTP = useSelector(selectOTP);
  const inputs = useRef([]);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoBase64, setPhotoBase64] = useState(null);
  const fileInputRef = useRef(null);
  const [showPhotoModal, setShowPhotoModal] = useState(false);

  const passwordValue = watch("Password"); // Watch password field

  // 🔹 Trigger revalidation of confirmPassword when password changes
  useEffect(() => {
    trigger("confirmPassword");
  }, [passwordValue, trigger]);
  useEffect(() => {
    dispatch(fetchStateDataAsync());
    dispatch(fetchIDTypeData());
    dispatch(fetchRelationData());
    dispatch(fetchGender());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState) {
      dispatch(fetchDistrictDataAsync(selectedState));
    } else if (user?.state) {
      dispatch(fetchDistrictDataAsync(user?.state));
    }
  }, [dispatch, selectedState, state, user]);

  useEffect(() => {
    console.log("State Options:", stateOptions);
    console.log("District Options:", districtOptions);
    console.log("User State:", user?.state);
    console.log("User District:", user?.district);
  }, [stateOptions, districtOptions, user]);

  useEffect(() => {
    // Prefill form fields with user data
    if (user && !isOTPVerified) {
      const formattedUserDOB = user?.dob ? user.dob.split("T")[0] : "";
      console.log("userDOB:", user?.dob);
      setValue("aadhaar_ekyc", user?.aadhaar_ekyc);
      setValue("gender", user?.addGender);
      setValue("villageTownCity", user?.addVTC);
      setValue("street", user?.area);
      setValue("category", user?.category);
      setValue("country", user?.country);
      setValue("district", user?.district);
      if (!isOTPVerified) {
        setValue("dob", formattedUserDOB);
        console.log("formattedUserDOB:", formattedUserDOB);
      }

      setValue("house", user?.houseNo);
      setValue("email", user?.email);
      setValue("firstName", user?.firstName);
      setValue("identificationNumber", user?.identificationNumber);
      setValue("identificationType", user?.identificationType);
      setValue("lastName", user?.lastName);
      setValue("landmark", user?.locality);
      setValue("middleName", user?.middleName);
      setValue("MobileNo", user?.mobileNo);
      setValue("password", user?.password);
      setValue("Photo", user?.photo);
      setValue("pincode", user?.pinCode);
      setValue("relation", user?.relationship);
      setValue("fatherName", user?.relative);
      setValue("Relegion", user?.relegion);
      setValue("role", user?.role);
      setValue("state", user?.state);
      setValue("status", user?.status);
      setValue("userId", user?.userId);
      setValue("username", user?.username);
      setValue("whatsApp_No", user?.whatsApp_No || "");
    }
  }, [user, setValue, isOTPVerified]);

  useEffect(() => {
    if (isOTPVerified && aadhaarDetails?.dob) {
      const formattedDOB = aadhaarDetails.dob
        ? aadhaarDetails.dob.split("-").reverse().join("-") // Convert "11-11-1983" to "1983-11-11"
        : aadhaarDetails.dob;
      console.log("aadhaarDOB:", aadhaarDetails.dob);

      setValue("identificationType", "04");
      setValue("identificationNumber", aadhaarNumber || "");
      // setValue("dob", formattedAadhaarDOB || "");
      setValue("dob", formattedDOB, {
        shouldDirty: true,
        shouldValidate: true,
      });
      console.log("formattedAadhaarDOB:", formattedDOB);
      setValue("email", user?.email);
      setValue("MobileNo", user?.mobileNo);
      setValue("whatsApp_No", user?.whatsApp_No);
      setValue("username", user?.username);
      setValue("category", user?.category);
      setValue("Relegion", user?.relegion);

      // Map Aadhaar details only if they change
      Object.entries(aadhaarDetails).forEach(([key, value]) => {
        setValue(key, value || "");
      });

      // Handle state mapping
      const stateID = stateOptions.find(
        (state) =>
          state.stateName.toLowerCase() === aadhaarDetails.state.toLowerCase()
      )?.stateID;
      const districtID = districtOptions.find(
        (district) =>
          district.districtName.toLowerCase() ===
          aadhaarDetails.district.toLowerCase()
      )?.districtID;
      setValue("state", stateID);
      setValue("district", districtID);

      // Map relation
      if (aadhaarDetails.relation) {
        const selectedRelation = relationData.find(
          (relation) =>
            relation.relation?.toLowerCase() ===
            aadhaarDetails.relation?.toLowerCase()
        );
        if (selectedRelation) {
          setValue("relation", selectedRelation.relatioN_CODE);
        } else {
          console.error(
            "Relation not found in relationData:",
            aadhaarDetails.relation
          );
        }
      }

      // Map gender
      if (aadhaarDetails.gender) {
        const mappedGenderCode =
          aadhaarDetails.gender === "M"
            ? "01"
            : aadhaarDetails.gender === "F"
            ? "02"
            : "";
        setValue("gender", mappedGenderCode || "");
      }
    }
  }, [dispatch, setValue, aadhaarDetails, isOTPVerified]);

  console.log("Final DOB in form:", watch("dob")); // Check actual form value

  const getIdTypeName = (code) => {
    const idType = idTypeData.find((item) => item.iD_CODE === code);
    return idType ? idType.id : "Unknown"; // return "Unknown" if the code is not found
  };

  const getRelationTypeName = (code) => {
    const relation_type = relationData.find(
      (item) => item.relatioN_CODE === code
    );
    return relation_type ? relation_type.relation : "Unknown"; // return "Unknown" if the code is not found
  };

  const getStateName = (code) => {
    const state_Name = stateOptions.find(
      (item) => item.stateID === Number(code)
    );
    return state_Name ? state_Name.stateName : "Unknown"; // return "Unknown" if the code is not found
  };
  const getDistrictName = (code) => {
    const district_Name = districtOptions.find(
      (item) => item.districtID === Number(code)
    );
    return district_Name ? district_Name.districtName : "Unknown"; // return "Unknown" if the code is not found
  };

  const handlePasswordOTPChange = (index, value) => {
    if (value.length > 1) return; // Allow only one digit per input
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  };

  // Resend OTP Function
  const handleResendOtp = () => {
    setTimeLeft(30);
    setCanResend(false);
    setOtp(new Array(6).fill("")); // Reset OTP fields
  };

  const handleInputChange = (index, e) => {
    const digit = e.target.value.slice(-1);
    if (/^\d$/.test(digit)) {
      inputs.current[index].value = digit;
      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    } else {
      inputs.current[index].value = "";
    }
    setOtp(inputs.current.map((input) => input.value).join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (inputs.current[index].value === "" && index > 0) {
        inputs.current[index - 1].focus();
      } else {
        inputs.current[index].value = "";
        e.preventDefault();
      }
    }
  };

  const handleEkycClick = () => {
    console.log("E-KYC Button Clicked, ekyc value:", ekyc);

    setShowEkycForm(true); // ✅ Update state correctly
    setShowEditForm(false);

    // Debugging to check state change
    setTimeout(() => {
      console.log("showEkycForm:", showEkycForm);
      console.log("showEditForm:", showEditForm);
    }, 100);
  };

  const handleGetAadhaarOtp = () => {
    // Check if Aadhaar number matches user.IdNo
    if (aadhaarNumber) {
      // Check if Aadhaar number is a valid 12 digits number
      if (/^\d{12}$/.test(aadhaarNumber)) {
        dispatch(checkAadhaarAsync({ Aadhaar: aadhaarNumber }));
      } else {
        setError("Please enter a valid 12-digit Aadhaar number to get OTP");
      }
    } else {
      // Show toast error if Aadhaar doesn't match user.IdNo
      toast.error("Invalid Aadhaar number");
    }
  };

  const handleGetOtp = async () => {
    const newPassword = watch("Password");
    const confirmPassword = watch("confirmPassword");

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      toast.error("New Password and Confirm Password do not match!");
      return;
    }
    try {
      const result = await dispatch(checkUserMobileAsync(user?.mobileNo));

      console.log(result);

      if (result.payload.status === 200) {
        dispatch(setOTP(result.payload.otp));
      } else {
        toast.error("Error Sending OTP");
        setError("Error Sending OTP");
      }
    } catch (error) {
      setError("Invalid Credential");
    }
  };

  const handleOTPSubmit = async () => {
    const newPassword = watch("Password");
    console.log(otp);
    // e.preventDefault();
    if (mobotp === enteredOtp) {
      try {
        toast.success("OTP Verified");
        dispatch(setOTP("")); // Navigate to "/dummy" if OTP verification is successful

        const requestData = {
          mobileno: user?.mobileNo, // Replace with actual mobile number
          password: newPassword, // Replace with actual password
        };

        // API call
        const res = await axios.post(
          `${API_BASE_URL}/Auth/Profile_UpdatePassword`,
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Response:", res.data);

        if (res.data.statusCode === "200") {
          setShowPasswordUpdateSuccessForm(true);
          setShowPasswordForm(false);
          toast.success("Password Updated!");
        } else {
          toast.error("Error updating Password");
        }
      } catch (error) {
        toast.error("Invalid OTP");
        console.error("OTP verification failed:", error);
      }
    } else {
      console.error("OTP does not match");
    }
  };

  const onSubmit = async (data) => {
    console.log("dataaaaaaaaaa:", data);
    try {
      // Construct API payload with Basic Details & Address Details
      const payload = {
        ...data,
        // Photo: aadhaarDetails?.photo || "",
        Photo: photoBase64 ?? aadhaarDetails?.photo ?? (user?.photo || ""),
      };

      console.log("Payload:", payload);
      // Dispatch API call
      const result = await dispatch(createUserAsync(payload));

      // Handle success response
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("User Profile Updated successfully!");
      } else {
        toast.error("Failed to create user");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleGetAadhaarDetails = () => {
    if (otp !== "" && otp === storedOTP) {
      console.log("OTP Verified Successfully");
      toast.success("OTP matched!");
      // dispatch(setOTPVerified(true));
      dispatch(fetchAadhaarDetailsAsync(aadhaarNumber))
        .then(() => {
          console.log("Aadhaar details fetched successfully");
          setShowEkycForm(false);
          setShowEditForm(true);
          dispatch(setOTPVerified(true));

          // onClose(); // Close the modal after fetching details
        })
        .catch((error) => {
          console.error("Error fetching Aadhaar details:", error);
        });
    } else {
      console.error("Invalid OTP");
      toast.error("Invalid OTP! Please Check");
    }
  };

  const handleCancel = () => {
    dispatch(resetAadhaarOTPVerified());
    dispatch(clearAadhaarDetails());
    setShowEkycForm(false);
    setShowEditForm(false);
    clearSelectedPhoto();
  };

  // const openPhotoPicker = () => {
  //   if (fileInputRef.current) fileInputRef.current.click();
  // };
  const openPhotoPicker = () => {
    if (!showEditForm) {
      toast.info("Click 'Edit Details' to change your photo.");
      return;
    }
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const openPhotoModal = () => setShowPhotoModal(true);
  const closePhotoModal = () => setShowPhotoModal(false);

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowed = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowed.includes(file.type)) {
      toast.error("Only JPG/JPEG/PNG are allowed.");
      e.target.value = "";
      return;
    }

    const MAX = 2 * 1024 * 1024; // 2 MB
    if (file.size > MAX) {
      toast.error("Max size 2 MB.");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result; // data URL
      setPhotoPreview(result); // full data URL for preview
      setPhotoBase64((result || "").split(",")[1] || ""); // strip header for payload
    };
    reader.onerror = () => toast.error("Failed to read image.");
    reader.readAsDataURL(file);
  };

  const clearSelectedPhoto = () => {
    setPhotoPreview(null);
    setPhotoBase64(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <>
      <Navbar />
      <div className="max-w-7xl w-full mx-auto my-10 3xl:my-20 bg-white border border-blue-100 rounded-xl overflow-y-auto md:overflow-hidden">
        {/* Profile Header with Background Image */}
        <div
          className="relative h-24 bg-cover bg-center rounded-t-lg"
          style={{ backgroundImage: `url(${accbgimg})` }}
        >
          {/* Profile Image */}
          <div className="absolute left-4 md:left-8 bottom-[-65px] flex items-center space-x-4">
            {/* <div
              className="w-20 h-20 rounded-full border-8 border-white bg-white z-10 bg-cover bg-center"
              // style={{ backgroundImage: `url(${accpngprofpic})` }}
              style={{
                backgroundImage: user.photo
                  ? `url(data:image/jpeg;base64,${user.photo})`
                  : `url(${accpngprofpic})`,
              }}
            ></div> */}
            <div className="relative">
              {/* avatar */}
              <div
                onClick={openPhotoModal}
                title="View photo"
                className="w-20 h-20 rounded-full border-8 border-white bg-white z-10 bg-cover bg-center cursor-pointer"
                style={{
                  backgroundImage: photoPreview
                    ? `url(${photoPreview})`
                    : user.photo
                    ? `url(data:image/jpeg;base64,${user.photo})`
                    : `url(${accpngprofpic})`,
                }}
              />

              {/* small edit chip (works only in edit mode) */}
              <button
                type="button"
                onClick={openPhotoPicker}
                className={`absolute right-0 bottom-0 text-[10px] px-2 py-0.5 rounded-full 
                ${
                  showEditForm
                    ? "bg-black/70 text-white"
                    : "bg-gray-300 text-gray-600 cursor-not-allowed"
                }`}
                title={
                  showEditForm
                    ? "Change photo"
                    : "Enable 'Edit Details' to change"
                }
              >
                Edit
              </button>

              <input
                ref={fileInputRef}
                type="file"
                accept=".jpg,.jpeg,.png"
                className="hidden"
                onChange={handlePhotoChange}
              />
            </div>

            <div className="mt-20 bg-white">
              <h2 className="text-xl text-[#145EB5] font-semibold flex items-center space-x-2">
                {`${user?.firstName} ${
                  user?.middleName ? user?.middleName + " " : ""
                }${user?.lastName}`}
                {ekyc === "Y" ? (
                  <div
                    className="w-4 h-4 bg-cover bg-center mx-2"
                    style={{ backgroundImage: `url(${checkIcon})` }}
                  ></div>
                ) : (
                  <div
                    className="w-4 h-4 bg-cover bg-center mx-2"
                    style={{ backgroundImage: `url(${namesidestar})` }}
                  ></div>
                )}
              </h2>

              <div className="flex space-x-2 mt-1">
                {ekyc === "N" && (
                  <>
                    <span className="px-2 py-0.5 bg-[#FFF8E0] text-xs text-[#B46F00] rounded">
                      e-kyc Pending
                    </span>
                  </>
                )}
                <button
                  onClick={handleEkycClick}
                  className="px-2 py-0.5 border border-[#00B451] text-xs text-[#00B451]"
                >
                  {ekyc === "N" ? "e-kyc Now!" : "Click for Re-Ekyc"}
                </button>
              </div>
            </div>
          </div>

          {/* Edit Button */}
          {!showEkycForm && !showEditForm && ekyc === "N" && (
            <button
              onClick={() => {
                setShowEditForm(true);
              }}
              className="absolute md:top-28 top-36 md:right-6 right-1 md:text-base text-xs bg-[#4F9CF9] text-white hover:bg-[#255692] md:px-4 px-2 md:py-1 py-1 rounded-full flex items-center"
            >
              Edit Details
              <div
                className="md:w-4 md:h-4 w-1 h-1 bg-cover bg-center ml-2"
                style={{ backgroundImage: `url(${editicon})` }}
              ></div>
            </button>
          )}
          {showEkycForm && (
            <div className="absolute md:top-28 top-36 md:right-6 right-1 flex space-x-2">
              <button className="md:text-base text-xs bg-[#8898ac] text-white hover:bg-[#546274] md:px-4 px-2 md:py-1 py-1 rounded-full flex items-center">
                Update e kyc
                <div
                  className="md:w-4 md:h-4 w-1 h-1 bg-cover bg-center ml-2"
                  style={{ backgroundImage: `url(${editicon})` }}
                ></div>
              </button>
              <button
                onClick={handleCancel}
                className="md:text-base text-xs border-[#D80000] border text-[#D80000] hover:bg-[#D80000] hover:text-[#ffffff] md:px-4 px-2 md:py-1 py-1 rounded-full flex items-center"
              >
                Cancel X
              </button>
            </div>
          )}

          {!showEkycForm && showEditForm && (
            <div className="absolute md:top-28 top-36 md:right-6 right-1 flex space-x-2">
              <button
                onClick={handleSubmit(onSubmit)}
                className="md:text-base text-xs bg-[#4F9CF9] text-white hover:bg-[#255692] md:px-4 px-2 md:py-1 py-1 rounded-full flex items-center"
              >
                {ekyc === "Y" ? "Update e-KYC" : "Save"}
                <div
                  className="md:w-4 md:h-4 w-1 h-1 bg-cover bg-center ml-2"
                  style={{ backgroundImage: `url(${editicon})` }}
                ></div>
              </button>
              <button
                // onClick={() => {
                //   setShowEditForm(false);
                // }}
                onClick={handleCancel}
                className="md:text-base text-xs border-[#D80000] border text-[#D80000] hover:bg-[#D80000] hover:text-[#ffffff] md:px-4 px-2 md:py-1 py-1 rounded-full flex items-center"
              >
                Cancel X
              </button>
            </div>
          )}
        </div>

        {/* User Details Section */}
        {!showEkycForm && !showEditForm && (
          <div className="p-6 grid md:grid-cols-3 gap-4 mt-16">
            {/* Basic Details */}
            <div className="rounded-lg shadow-md">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Basic Details :
                </h3>
              </div>
              <div className="px-4 space-y-2 p-3">
                <div className="grid grid-cols-2 gap-x-4">
                  <p className="text-xs">
                    <h3 className="text-[#818181]">Date Of Birth:</h3>{" "}
                    {user?.dob
                      ? new Date(
                          user.dob.includes("T")
                            ? user.dob.split("T")[0]
                            : user.dob.replace(/-/g, "/")
                        ).toLocaleDateString("en-IN")
                      : ""}
                  </p>
                  <p className="text-xs">
                    <h3 className="text-[#818181]">Category:</h3>{" "}
                    {user?.category || ""}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-x-4">
                  <p className="text-xs">
                    <h3 className="text-[#818181]">Mobile No.:</h3> +91{" "}
                    {user?.mobileNo}
                  </p>
                  <p className="text-xs">
                    <h3 className="text-[#818181]">ID Type:</h3>{" "}
                    {getIdTypeName(user?.identificationType)}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-x-4">
                  <p className="text-xs">
                    <h3 className="text-[#818181]">Email ID:</h3>{" "}
                    {user?.email || ""}
                  </p>
                  <p className="text-xs">
                    <h3 className="text-[#818181]">ID No.:</h3>{" "}
                    {user?.identificationNumber || ""}
                  </p>
                </div>

                <p className="text-xs">
                  <h3 className="text-[#818181]">Whatsapp No:</h3> +91{" "}
                  {user?.whatsApp_No || ""}
                </p>
                <p className="text-xs">
                  <h3 className="text-[#818181]">Relation Type:</h3>{" "}
                  {getRelationTypeName(user?.relationship)}
                </p>
                <p className="text-xs">
                  <h3 className="text-[#818181]">Full Name:</h3>{" "}
                  {`${user?.firstName} ${
                    user?.middleName ? user?.middleName + " " : ""
                  }${user?.lastName}`}
                </p>
                <p className="text-xs">
                  <h3 className="text-[#818181]">Religion:</h3>{" "}
                  {user?.relegion || ""}
                </p>
              </div>
            </div>

            {/* Address Details */}
            <div className="rounded-lg shadow-md">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Address Details :
                </h3>
              </div>
              <div className="px-4 space-y-2 p-3">
                <p className="text-xs">
                  <h3 className="text-[#818181]">Country:</h3>{" "}
                  {user?.country || ""}
                </p>
                <p className="text-xs">
                  <h3 className="text-[#818181]">State:</h3>{" "}
                  {getStateName(user?.state)}
                </p>
                <p className="text-xs">
                  <h3 className="text-[#818181]">City:</h3>{" "}
                  {getDistrictName(user?.district)}
                </p>
                <p className="text-xs">
                  <h3 className="text-[#818181]">Pincode:</h3>{" "}
                  {user?.pinCode || ""}
                </p>
              </div>
            </div>

            {/* Password Details */}
            <div className="rounded-lg shadow-md">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Password Details :
                </h3>
              </div>
              <div className="px-4 space-y-2 p-3">
                <p className="text-xs">
                  <h3 className="text-[#818181]">Current Password:</h3>{" "}
                  *********
                </p>
              </div>
            </div>
          </div>
        )}

        {!showEkycForm && showEditForm && (
          <div className="p-6 grid md:grid-cols-3 gap-4 mt-16">
            {/* Basic Details */}
            <div className="rounded-lg shadow-md">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Basic Details :
                </h3>
              </div>

              <div className="px-4 space-y-3 p-3 max-h-96 overflow-y-auto">
                {/* Date of Birth */}
                <div className="relative">
                  <input
                    id="dob"
                    type="date"
                    {...register("dob", {
                      required: "Date of Birth is required",
                    })}
                    value={watch("dob") || ""} // Explicitly bind value
                    onChange={(e) => setValue("dob", e.target.value)} // Ensure manual updates work
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="dob"
                    className="absolute text-xs text-black duration-300 transform -translate-y-4 scale-75 top-2 left-2 bg-white px-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4"
                  >
                    Date of Birth
                  </label>
                </div>

                {/* Mobile Verification */}
                <VerificationSection
                  label="Mobile"
                  id="MobileNo"
                  field="mobile"
                  register={register}
                  getValues={getValues}
                  setValue={setValue}
                  watch={watch}
                  validation={{
                    required: "Mobile Number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter a valid 10-digit mobile number",
                    },
                  }}
                  disabled={true} // Disable input
                  hideButton={true} // Hide Change button
                  fetchOtpAction={fetchOTPs}
                />
                {errors.MobileNo && (
                  <p className="text-red-500 text-xs">
                    {errors.MobileNo.message}
                  </p>
                )}

                <VerificationSection
                  label="email"
                  id="email"
                  field="email"
                  register={register} // ✅ Pass register here
                  getValues={getValues}
                  setValue={setValue} // ✅ Pass setValue to update values
                  watch={watch}
                  validation={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email address",
                    },
                  }}
                  disabled={true} // Disable input
                  hideButton={true} // Hide Change button
                  fetchOtpAction={fetchOTPs}
                />
                {errors.email && (
                  <p className="text-red-500 text-xs">{errors.email.message}</p>
                )}

                <VerificationSection
                  label="WhatsApp"
                  id="whatsApp_No"
                  field="whatsApp_No"
                  register={register} // ✅ Pass register here
                  getValues={getValues}
                  setValue={setValue} // ✅ Pass setValue to update values
                  watch={watch}
                  validation={{
                    // required: "WhatsApp Number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter a valid 10-digit WhatsApp number",
                    },
                  }}
                  fetchOtpAction={fetchOTPs}
                />
                {errors.WhatsApp && (
                  <p className="text-red-500 text-xs">
                    {errors.WhatsApp.message}
                  </p>
                )}

                {/* Relation Type and Relative Name */}
                <div className="grid grid-cols-3 gap-x-0">
                  <div className="col-span-1">
                    <div className="relative">
                      <select
                        id="relation"
                        {...register("relation", {
                          required: "Relation is required",
                        })}
                        required
                        className="w-full border border-[#B1B1B1] border-r-white rounded-l-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                      >
                        {relationData?.map((option) => (
                          <option
                            key={option.relatioN_CODE}
                            value={option.relatioN_CODE}
                          >
                            {option.relation}
                          </option>
                        ))}
                      </select>
                      <label
                        htmlFor="Rel"
                        className="    absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                      >
                        Rel.Type
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        type="text"
                        id="Relative"
                        required
                        {...register("fatherName", {
                          required: "Name is required",
                        })}
                        className="w-full border border-[#B1B1B1] rounded-r-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                      />
                      <label
                        htmlFor="Relative"
                        className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                      >
                        Relative Name
                      </label>
                    </div>
                  </div>
                </div>

                {/* Religion */}
                <div className="relative">
                  <select
                    id="Relegion"
                    {...register("Relegion", {
                      required: "Relegion is required",
                    })}
                    required
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  >
                    <option value="">Relegion</option>
                    <option value="hindu">Hindu</option>
                    <option value="muslim">Muslim</option>
                    <option value="christian">Christian</option>
                    <option value="other">Other</option>
                  </select>
                  <label
                    htmlFor="Religion"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Religion
                  </label>
                </div>

                <div className="relative">
                  <select
                    id="Category"
                    {...register("category", {
                      required: "Category is required",
                    })}
                    required
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  >
                    <option value="">Category</option>
                    <option value="general">General</option>
                    <option value="sc">SC</option>
                    <option value="st">ST</option>
                    <option value="obc">OBC</option>
                  </select>
                  <label
                    htmlFor="Category"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Category
                  </label>
                </div>
                <div className="relative">
                  <select
                    id="identificationType"
                    {...register("identificationType", {
                      required: "Identification type is required",
                      onChange: (e) => {
                        const selectedType = e.target.value;
                        setValue("identificationType", selectedType); // Update the type
                        setValue("identificationNumber", ""); // Reset number field
                        clearErrors("identificationNumber"); // Clear previous errors
                      },
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  >
                    {idTypeData.map((option) => (
                      <option key={option.iD_CODE} value={option.iD_CODE}>
                        {option.id}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="identificationType"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Id Type
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="IdNo"
                    type="text"
                    maxLength={
                      user?.identificationType === "02"
                        ? 10
                        : user?.identificationType === "04"
                        ? 12
                        : 100
                    }
                    {...register("identificationNumber", {
                      required: "Identification number is required",
                      validate: (value) => {
                        if (user?.identificationType === "02") {
                          return (
                            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value) ||
                            "Enter a valid PAN (ABCDE1234F format)"
                          );
                        }
                        if (user?.identificationType === "04") {
                          return (
                            /^[0-9]{12}$/.test(value) ||
                            "Enter a valid 12-digit Aadhaar number"
                          );
                        }
                        return true;
                      },
                      onChange: (e) => {
                        const value = e.target.value;
                        setValue("identificationNumber", value); // Update value
                        // Perform validation immediately
                        if (user?.identificationType === "02") {
                          if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
                            setError("identificationNumber", {
                              type: "manual",
                              message: "Enter a valid PAN (ABCDE1234F format)",
                            });
                          } else {
                            clearErrors("identificationNumber");
                          }
                        }
                        if (user?.identificationType === "04") {
                          if (!/^[0-9]{12}$/.test(value)) {
                            setError("identificationNumber", {
                              type: "manual",
                              message: "Enter a valid 12-digit Aadhaar number",
                            });
                          } else {
                            clearErrors("identificationNumber");
                          }
                        }
                      },
                    })}
                    required
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="IdNo"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Id No.
                  </label>
                </div>
                {errors.identificationNumber && (
                  <p className="text-red-500 text-xs lg:text-sm mt-1">
                    {errors.identificationNumber.message}
                  </p>
                )}
              </div>
            </div>

            {/* Address Details */}
            <div className="rounded-lg shadow-md">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Address Details :
                </h3>
              </div>
              <div className="px-4 space-y-3 p-3 overflow-y-auto">
                <div className="relative">
                  <select
                    id="Country"
                    required
                    {...register("country", {
                      required: "Country is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  >
                    <option value="">Country</option>
                    <option value="India">India</option>
                  </select>
                  <label
                    htmlFor="Country"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Country
                  </label>
                </div>

                <div className="relative">
                  <select
                    id="State"
                    required
                    {...register("state", {
                      required: "state is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  >
                    <option value="">State</option>
                    {stateOptions.map((option) => (
                      <option key={option.stateID} value={option.stateID}>
                        {option.stateName}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="State"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    State
                  </label>
                </div>

                <div className="relative">
                  <select
                    id="District"
                    required
                    {...register("district", {
                      required: "district is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  >
                    <option value="">District</option>
                    {districtOptions.map((option) => (
                      <option key={option.districtID} value={option.districtID}>
                        {option.districtName}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="District"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    District
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="village"
                    type="text"
                    required
                    {...register("villageTownCity", {
                      required: "Village/Town/City is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="village"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Village/Town/City
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="House"
                    type="text"
                    required
                    {...register("house", {
                      required: "House/Flat is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="House"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    House No
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="Landmark"
                    type="text"
                    required
                    {...register("landmark", {
                      required: "Landmark is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="Landmark"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Landmark
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="Street"
                    type="text"
                    required
                    {...register("street", {
                      required: "Street is required",
                    })}
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="Street"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4 "
                  >
                    Street
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="Pincode"
                    type="text"
                    required
                    {...register("pincode", {
                      required: "Pincode is required",
                      pattern: {
                        value: /^[0-9]{6}$/,
                        message: "Pincode must be a 6-digit number",
                      },
                    })}
                    inputMode="numeric" // Ensures that only numeric keypad is shown on mobile devices
                    maxLength={6} // Restrict input to 10 characters
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\D/g, ""))
                    }
                    className="w-full border border-[#B1B1B1] rounded-md px-2 py-1 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                  />
                  <label
                    htmlFor="Pincode"
                    className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
    peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
    peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                  >
                    Pincode
                  </label>
                </div>
              </div>
            </div>

            {/* Password Details */}
            <div className="rounded-lg shadow-md">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Password Details :
                </h3>
              </div>
              <div className="p-4 border-gray-300 w-full max-w-sm mx-auto">
                {/* Header Section */}
                <div className="flex justify-between items-center border-b pb-2">
                  <p className="text-xs">
                    <h3 className="text-[#818181]">Current Password:</h3>{" "}
                    *********
                  </p>
                  <span
                    className="text-blue-700 text-xs cursor-pointer"
                    onClick={() => setShowPasswordForm(!showPasswordForm)}
                  >
                    Change Password
                  </span>
                </div>

                {showPasswordForm && (
                  <div className="mt-4">
                    <h3 className="text-sm font-medium mb-2">
                      Change Password :
                    </h3>

                    {/* New Password Field */}
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "Password"}
                        placeholder="Enter New Password"
                        {...register("Password", {
                          required: "Password is required",
                          minLength: {
                            value: 6,
                            message: "Password must be at least 6 characters",
                          },
                        })}
                        defaultValue=""
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm pr-10 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      />
                      {/* Eye Icon Inside Input */}
                      <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i
                          className={`fas ${
                            showPassword ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-xs">
                        {errors.password.message}
                      </p>
                    )}

                    {/* Confirm Password Field */}
                    <div className="relative mt-2">
                      <input
                        type={showConfirmPassword ? "text" : "Password"}
                        placeholder="Confirm New Password"
                        {...register("confirmPassword", {
                          required: "Please confirm your password",
                          validate: (value) =>
                            value === watch("Password") ||
                            "Passwords do not match",
                        })}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm pr-10 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      />
                      {/* Eye Icon Inside Input */}
                      <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        <i
                          className={`fas ${
                            showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <p className="text-red-500 text-xs">
                        {errors.confirmPassword.message}
                      </p>
                    )}

                    {/* Send OTP Button */}
                    <button
                      onClick={handleGetOtp}
                      className="w-full bg-blue-500 text-white py-2 rounded-md text-sm font-medium mt-3"
                    >
                      Send OTP
                    </button>

                    {/* OTP Input Section */}
                    <p className="text-xs text-gray-600 mt-3">
                      Enter OTP Sent To Your Registered Mobile No.
                    </p>
                    <div className="flex justify-center gap-2 mt-2">
                      {mobotp && (
                        <OTPInput
                          length={4}
                          onOtpChange={setEnteredOtp}
                          // onResendOTP={handleSendOTP}
                        />
                      )}
                    </div>

                    {/* Submit Button */}
                    <button
                      onClick={handleOTPSubmit}
                      className="w-full bg-blue-500 text-white py-2 rounded-md text-sm font-medium mt-4"
                    >
                      Submit OTP & Update Password
                    </button>
                  </div>
                )}
              </div>
              {showPasswordUpdateSuccessForm && (
                <div className="text-center justify-items-center mt-14">
                  <img
                    src={passwordupdategif}
                    alt="Success"
                    className="mx-auto w-16 h-16"
                  />
                  <h1 className="text-[#009C78] mt-4">
                    Password Updated Successfully
                  </h1>
                </div>
              )}
            </div>
          </div>
        )}

        {!showEditForm && showEkycForm && (
          <div className="p-6 grid md:grid-cols-3 gap-4 mt-16">
            {/* Basic Details */}
            <div className="rounded-lg shadow-md col-span-2">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Basic Details :
                </h3>
              </div>

              <div className="px-1 space-y-1 p-1 max-h-96 overflow-y-auto">
                <div className="p-1">
                  <div className="grid grid-cols-5 gap-4 items-start">
                    <div className="col-span-2 relative">
                      <input
                        id="Aadhaar"
                        type="text"
                        placeholder=""
                        value={aadhaarNumber}
                        onChange={(e) => setAadhaarNumber(e.target.value)}
                        maxLength={12}
                        required
                        className="w-full border border-[#B1B1B1] rounded-md px-2 py-2 text-xs peer focus:border-blue-500 focus:outline-none focus:ring-0"
                      />

                      <label
                        htmlFor="Aadhaar"
                        className="absolute left-2 top-1 text-xs text-black bg-white px-1 transition-all 
     peer-placeholder-shown:top-1/2 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:scale-100
     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 
     peer-valid:top-2 peer-valid:scale-75 peer-valid:-translate-y-4"
                      >
                        Enter Your Aadhaar No..
                      </label>
                    </div>
                    <div className="col-span-1">
                      <button
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 text-xs"
                        onClick={handleGetAadhaarOtp}
                      >
                        Get OTP
                      </button>
                    </div>
                  </div>

                  <div className="mb-1 p-1 bg-white rounded-md mt-2">
                    <label className="block text-xs font-medium text-gray-700">
                      <input
                        type="checkbox"
                        checked={checkbox1}
                        onChange={() => setCheckbox1(!checkbox1)}
                        className="mr-2"
                      />
                      I Hereby State That I Have No Objection In Authentication
                      Myself With Aadhaar Based Authentication System and
                      Consent to Providing My Aadhaar Number, Biometric and/or
                      One-time Password (OTP) Data for Aadhaar Based
                      Authentication for the Purposes of Availing Benefits of
                      E-registration and E-stamp. I understand That the Aadhaar
                      Number, Biometric and/or OTP I Provide for Authentication
                      Shall Be Used
                      <ol className="list-decimal list-inside ml-4 mt-0">
                        <li>For Authenticating My Identity</li>
                        <li>For Authenticating Property Ownership</li>
                        <li>
                          For De-Duplication within Verticals of IGRS (Inspector
                          General of Registration and Stamps) and Other
                          Integrated Departments (UADD (Directorate of Urban
                          Administration), CLR (Commissioner Land Records and
                          Settlement))
                        </li>
                      </ol>
                    </label>
                    <label className="block text-xs font-medium text-gray-700 mt-1">
                      <input
                        type="checkbox"
                        checked={checkbox2}
                        onChange={() => setCheckbox2(!checkbox2)}
                        className="mr-2"
                      />
                      I Understand That IGRS (Inspector General of Registration
                      and Stamps), UADD (Directorate of Urban Administration),
                      CLR (Commissioner Land Records and Settlement) and T&CP
                      (Director of Town and Country Planning) shall Ensure
                      Security and Confidentiality of My Personal Identity Data
                      Provided for The Purpose of Aadhaar Based Authentication.
                    </label>
                  </div>

                  <h2 className="mt-2 text-sm font-medium">Enter OTP</h2>
                  <div className="flex">
                    <div className="flex gap-2 justify-center">
                      {[...Array(6)].map((_, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength={1}
                          className="form-control text-center w-10 border-gray-300 rounded-md shadow-sm"
                          ref={(el) => (inputs.current[index] = el)}
                          onChange={(e) => handleInputChange(index, e)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                        />
                      ))}
                    </div>
                    <button
                      onClick={handleGetAadhaarDetails}
                      className=" bg-blue-500 text-white py-1 rounded-full px-4 mx-2"
                    >
                      Verify OTP
                    </button>
                  </div>

                  <div className="flex justify-between items-center mt-3 text-sm">
                    <button
                      className={`text-blue-500 ${
                        canResend ? "" : "opacity-50"
                      }`}
                      onClick={handleResendOtp}
                      disabled={!canResend}
                    >
                      Resend OTP
                    </button>
                    <span className="text-gray-500">
                      00:{timeLeft.toString().padStart(2, "0")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Password Details */}
            <div className="rounded-lg shadow-md col-span-1">
              <div className="p-1 rounded-t-lg shadow-md bg-[#5E646A]">
                <h3 className="font-semibold text-base text-white px-3">
                  Password Details :
                </h3>
              </div>
              <div className="p-4 border-gray-300 w-full max-w-sm mx-auto">
                {/* Header Section */}
                <div className="flex justify-between items-center border-b pb-2">
                  <p className="text-xs">
                    <h3 className="text-[#818181]">Current Password:</h3>{" "}
                    ******879
                  </p>
                  <span
                    className="text-blue-700 text-xs cursor-pointer"
                    onClick={() => setShowPasswordForm(!showPasswordForm)}
                  >
                    Change Password
                  </span>
                </div>

                {/* Change Password Form (Shown on Click) */}
                {showPasswordForm && (
                  <div className="mt-4">
                    <h3 className="text-sm font-medium mb-2">
                      Change Password :
                    </h3>

                    <input
                      type="password"
                      placeholder="Enter New Password"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm mb-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                    <input
                      type="password"
                      placeholder="Confirm New Password"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm mb-3 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />

                    {/* Send OTP Button */}
                    <button className="w-full bg-blue-500 text-white py-2 rounded-md text-sm font-medium">
                      Send OTP
                    </button>

                    {/* OTP Input Section */}
                    <p className="text-xs text-gray-600 mt-3">
                      Enter OTP Sent To Your Registered Mobile No.
                    </p>
                    <div className="flex justify-center gap-2 mt-2">
                      {otpPassword.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength={1}
                          className="w-10 h-10 border border-gray-400 text-center text-lg rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                          value={digit}
                          onChange={(e) =>
                            handlePasswordOTPChange(index, e.target.value)
                          }
                        />
                      ))}
                    </div>

                    {/* Submit Button */}
                    <button
                      onClick={() => {
                        setShowPasswordUpdateSuccessForm(true);
                        setShowPasswordForm(false);
                      }}
                      className="w-full bg-blue-500 text-white py-2 rounded-md text-sm font-medium mt-4"
                    >
                      Submit OTP & Update Password
                    </button>
                  </div>
                )}
              </div>
              {showPasswordUpdateSuccessForm && (
                <div className="text-center justify-items-center mt-14">
                  <img
                    src={passwordupdategif}
                    alt="Success"
                    className="mx-auto w-16 h-16"
                  />
                  <h1 className="text-[#009C78] mt-4">
                    Password Updated Successfully
                  </h1>
                </div>
              )}
            </div>
          </div>
        )}

        {showPhotoModal && (
          <div className="fixed inset-0 z-50">
            {/* backdrop */}
            <div
              className="absolute inset-0 bg-black/50 backdrop-blur-sm"
              onClick={closePhotoModal}
            />

            {/* modal */}
            <div className="relative w-full h-full flex items-center justify-center p-4">
              <div className="relative bg-white rounded-xl shadow-xl max-w-[90vw] max-h-[85vh] p-3">
                {/* close */}
                <button
                  onClick={closePhotoModal}
                  className="absolute -top-3 -right-3 bg-white rounded-full shadow px-2 py-1 text-xs"
                >
                  ✕
                </button>

                {/* image */}
                <img
                  alt="Profile"
                  className="max-h-[75vh] max-w-[80vw] object-contain rounded-lg"
                  src={
                    photoPreview
                      ? photoPreview
                      : user.photo
                      ? `data:image/jpeg;base64,${user.photo}`
                      : accpngprofpic
                  }
                />

                {/* edit button inside modal (only works in edit mode) */}
                <div className="absolute right-3 top-3">
                  <button
                    type="button"
                    onClick={openPhotoPicker}
                    className={`flex items-center gap-2 text-xs px-3 py-1 rounded-full shadow 
                        ${
                          showEditForm
                            ? "bg-black/80 text-white"
                            : "bg-gray-300 text-gray-600 cursor-not-allowed"
                        }`}
                    title={
                      showEditForm
                        ? "Change photo"
                        : "Enable 'Edit Details' to change"
                    }
                  >
                    <span>Edit</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Profile;
